import WebLayout from "../layout/WebLayout";

function EquityShare() {
  return (
    <WebLayout pageName={EquityShare}>
      <div className="product-dContent__box">
        <div className="tab-content" id="pills-tabContent">
          <div
            className="tab-pane fade show active"
            id="pills-description"
            role="tabpanel"
            aria-labelledby="pills-description-tab"
            tabIndex="0">
            <div className="text-center">
              <h4 className="text-2xl mb-2">
                Investor Invitation – Ardh Sainik Mall DDC
              </h4>
              <h5 className="text-xl">
                Opportunity for Equity Participation – Minimum 100 Shares (₹2.5
                Lakhs)
              </h5>
            </div>
            <hr></hr>
            <div className="mb-20">
              <h6 className="mb-10">Dear Investor,</h6>
              <p className="mb-2">
                We are pleased to invite you to be part of a transformative
                national movement — Ardh Sainik Mall DDC (District Distribution
                and Display Centre) — a hybrid retail + wholesale + digital
                platform designed to empower Indian MSMEs and honor the soldier
                community through a structured, district-level business model.
              </p>
              <h6 className="mt-10 mb-10">🎯 Our Vision</h6>
              <p>
                To build India’s most trusted soldier-led distribution network
                that connects local manufacturing to village-level consumption,
                with dignity, discipline, and digital efficiency.
              </p>
              <h6 className="mt-10 mb-10">📌 Our Mission</h6>
              <ul style={{ paddingLeft: "20px" }}>
                <li className="mb-5">
                  -To establish 800+ Ardh Sainik Mall DDCs (One District – One
                  DDC) across India by 2027
                </li>
                <li className="mb-5">
                  -To empower ex-servicemen, youth, and women through
                  franchise-led retail ownership
                </li>
                <li className="mb-5">
                  -To support over 50,000 MSME manufacturers via our B2B portal
                  www.IndianMSME.org
                </li>
                <li className="mb-5">
                  -To enable 1,00,000 village-level canteens under the 'One
                  Village – One Canteen' model
                </li>
              </ul>
              <h6 className="mt-10 mb-10">📈 Equity Offer</h6>
              <ul style={{ paddingLeft: "20px" }}>
                <li className="mb-5">
                  -Minimum Investment: ₹2.5 Lakhs (100 Equity Shares @ ₹2,500
                  each)
                </li>
                <li className="mb-5">
                  -Holding Entity: ASC Distributor Pvt. Ltd.
                </li>
                <li className="mb-5">
                  -Ownership Benefits:
                  <ul className="list-inside mt-10 ms-16">
                    <li className="mb-5">
                      Annual dividend payout (from net profits)
                    </li>
                    <li className="mb-5">
                      Share value appreciation with national rollout
                    </li>
                    <li className="mb-5">
                      Strategic priority in opening DDCs or canteens in your
                      district
                    </li>
                    <li className="mb-5">Legacy asset for long-term holding</li>
                  </ul>
                </li>
              </ul>
              <h6 className="mt-10 mb-10">🔮 Future Outlook</h6>
              <ul style={{ paddingLeft: "20px" }}>
                <li className="mb-5">
                  -₹830+ Cr projected turnover by FY 2027
                </li>
                <li className="mb-5">
                  -₹288 Cr+ expected PAT (Profit After Tax)
                </li>
                <li className="mb-5">
                  -Employment generation for 1 lakh+ citizens
                </li>
                <li className="mb-5">
                  -Distribution-led Make in India ecosystem integrated with
                  Digital India platforms
                </li>
              </ul>
              <p className="mb-10">
                If you believe in nation-building through ethical business,
                soldier empowerment, and the growth of Indian MSMEs, we invite
                you to invest and grow with us.
              </p>
              <p className="mb-10">
                Let’s build the distribution system of tomorrow — for those who
                protected our today.
              </p>
              <p>
                <em>Warm regards,</em>
              </p>
              <p>Team Ardh Sainik Mall DDC</p>
              <p>📩 home@ardhsainik.com</p>
              <p>📞 +91-9971713965</p>
            </div>
          </div>
        </div>
      </div>
    </WebLayout>
  );
}

export default EquityShare;
